module.exports = __webpack_public_path__ + "img/BE0830597835.6c3d669c.svg";